import React from 'react';
import styled from 'styled-components';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';

import Typography from '@latitude/typography';
import SvgInline from '@/components/SvgInline/SvgInline';
import Icon from '@/components/Icon/Icon';
import { Link } from '@latitude/link';
import { REBRAND_COLOR, BREAKPOINT } from '@latitude/core/utils/constants';
import { ICON_VARIANT, ICON_SIZE } from '@/utils/constants';

const StyledLink = styled(Link)`
  border-radius: 16px;
  display: flex;
  border-bottom: none !important;
  text-shadow: none !important;
  min-height: 80px;
  padding: 16px 32px;

  cursor: ${({ hasUrl }) => (hasUrl ? 'pointer' : 'default')};

  background-color: ${({ themeType }) => {
    switch (themeType?.toLowerCase()) {
      case 'white':
        return REBRAND_COLOR.STONE;
      case 'stone':
        return REBRAND_COLOR.WHITE;
      default:
        return REBRAND_COLOR.STONE;
    }
  }};

  flex: 0 1 100%;
  max-width: 100%;

  @media (min-width: ${BREAKPOINT.MD}) {
    flex: 0 1
      calc(100% / ${({ numOfPoints }) => (numOfPoints > 1 ? 2 : 1)} - 30px);

    max-width: 540px;
  }

  @media (min-width: ${BREAKPOINT.LG}) {
    flex: 0 1
      calc(
        100% / ${({ numOfPoints }) => (numOfPoints > 2 ? 3 : numOfPoints)} -
          30px
      );

    max-width: 540px;
  }

  @media (min-width: ${BREAKPOINT.XL}) {
    flex: 1 1
      calc(
        100% / ${({ numOfPoints }) => (numOfPoints > 3 ? 4 : numOfPoints)} -
          30px
      );

    max-width: 540px;
  }

  @media (max-width: ${BREAKPOINT.SM}) {
    height: 120px;
    padding: 16px 32px;
  }
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-basis: 100%;
`;

const StyledSvgInline = styled(SvgInline)`
  flex-shrink: 0;
  flex-grow: 0;
  width: 40px !important;
  height: 40px !important;
`;

const ArrowIcon = styled(Icon)`
  margin-left: auto;
  flex-shrink: 0;
  flex-grow: 0;
  padding: 5px;
`;

const ProofPoint = ({
  point,
  proofPointTitleSize,
  theme,
  numOfPoints = 3,
  category,
  action
}) => {
  const TITLE_OPTIONS = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => (
        <Typography.CTALarge color={REBRAND_COLOR.BLACK}>
          {children}
        </Typography.CTALarge>
      )
    }
  };

  return (
    <StyledLink
      href={point?.proofPointUrl}
      hasUrl={!!point?.proofPointUrl}
      themeType={theme}
      numOfPoints={numOfPoints}
      target="_self"
      trackEventData={{
        label: point?.name,
        location: point?.name,
        category,
        action
      }}
    >
      <Content>
        {point?.icon && <StyledSvgInline name={point?.icon} />}

        {documentToReactComponents(point?.title, TITLE_OPTIONS)}

        {point?.proofPointUrl && (
          <ArrowIcon
            variant={ICON_VARIANT.ARROW_CHEVRON_RIGHT}
            size={ICON_SIZE.SM}
            color={REBRAND_COLOR.MID_BLUE}
          />
        )}
      </Content>
    </StyledLink>
  );
};

export default ProofPoint;